<template>
    <div class="form-group">
        <label class="label required">Price</label>
        <div class="row p-0">
            <div class="col-4 p-0">
                <app-input 
                    :placeholder="$t('Currency')"
                    type="advance-search-select"
                    fetch-url="/currency/serverside/selectable-name"
                    listValueField="Code"
                    v-model="internalValue.currency"
                    :loaded-per-time="5"
                    :required="true"
                    @input="updateValue"
                    :disabled="is_view"
                />
            </div>
            <div class="col-4 p-0">
                <app-input 
                    type="text"
                    v-model="displayValue" 
                    :placeholder="'Value'"
                    :required="true"
                    :disabled="is_view"
                    @input="updateValue"
                    @blur="rawInput = ''"
                />
            </div>
            <div class="col-4 p-0">
                <app-input 
                   :placeholder="$t('Unit')"
                    type="advance-search-select"
                    fetch-url="/units/serverside/selectable-name"
                    listValueField="code"
                    v-model="internalValue.unit"
                    :loaded-per-time="5"
                    :required="true"
                    @input="updateValue"
                    :disabled="is_view"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Price',
    props: {
        value: {
            type: Object,
            default: () => ({
                currency: '',
                value: '',
                unit: {
                    id:'', code:'', factor:''
                }
            })
        },
        is_view : {
            type : Boolean,
            default : false,
        },
    },
    data() {
        return {
            isTypingDot: false,
            rawInput: '',
            internalValue: { ...this.value }
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.internalValue = { ...newValue };
            },
            deep: true
        }
    },
    
    computed : {
        displayValue: {
            get() {
                const val = this.internalValue.value;
                if (val === null || val === '') return this.rawInput || '';
                if (this.rawInput !== '') return this.rawInput;
                return new Intl.NumberFormat('en-US').format(val);
            },
            set(newValue) {
                const cleanValue = newValue.replace(/[^0-9.]/g, '');
                this.rawInput = cleanValue;
                if (cleanValue.endsWith('.')) {
                    this.isTypingDot = true;
                    return;
                }
                this.isTypingDot = false;
                const numericValue = cleanValue === '' ? null : parseFloat(cleanValue);
                if (!isNaN(numericValue) || cleanValue === '') {
                    this.internalValue.value = numericValue;
                    this.updateValue();
                }
            }
        }
    },

    methods: {
        updateValue() {
            this.$emit('input', { ...this.internalValue });
        }
    }
}
</script>

<style scoped>
    .label {
        font-weight: 600;
    }
    /* Quitamos paddings laterales de la fila interna para alinear con el label */
    .row {
        margin-left: 0;
        margin-right: 0;
    }
</style>